export default "__VITE_ASSET__B5Ag23mm__"